import { useFormikContext, withFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { AuthShell } from "../register/auth-shell";
import "../register/auth-ui.css";
import { OrButton } from "../shared_modules/ui/components/atoms/or-button/or-button";
import { MdiEye, MdiEyeOff } from "../shared_modules/ui/components/atoms/or-icon";
import { OrInput } from "../shared_modules/ui/components/atoms/or-input/or-input";
import { showOrToast } from "../shared_modules/ui/components/atoms/or-toast/or-toast";
import { useUserRepository } from "../user/useUserRepository";

export default function RetrieveValidate() {
  const { recoverPasswordValidate } = useUserRepository();
  const navigate = useNavigate();

  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  let token = "";

  if (params.get("token")) {
    token = params.get("token");
  }

  const FormView = (props) => {
    const { setFieldValue } = useFormikContext();
    const { values, touched, errors, isSubmitting, handleChange, handleSubmit } = props;

    return (
      <form className="or-auth-form" onSubmit={handleSubmit}>
        <div className="or-auth-form__group">
          <OrInput
            id="password"
            inputType={values.showPassword ? "text" : "password"}
            label="Contraseña *"
            name="password"
            onChange={handleChange}
            placeholder="********************"
            value={values.password}
            hasError={touched.password && Boolean(errors.password)}
            errorText={touched.password ? errors.password : ""}
            rightSlot={
              <button
                className="or-auth-password-toggle"
                id="passwordicon"
                type="button"
                aria-label="toggle password visibility"
                onClick={() => setFieldValue("showPassword", !values.showPassword)}
              >
                {values.showPassword ? <MdiEyeOff /> : <MdiEye />}
              </button>
            }
          />
        </div>

        <div className="or-auth-form__group">
          <OrInput
            id="confirmpassword"
            inputType={values.showRepeatedPassword ? "text" : "password"}
            label="Repite la contraseña *"
            name="confirmpassword"
            onChange={handleChange}
            placeholder="********************"
            value={values.confirmpassword}
            hasError={touched.confirmpassword && Boolean(errors.confirmpassword)}
            errorText={touched.confirmpassword ? errors.confirmpassword : ""}
            rightSlot={
              <button
                className="or-auth-password-toggle"
                id="confirmpasswordicon"
                type="button"
                aria-label="toggle password visibility"
                onClick={() => setFieldValue("showRepeatedPassword", !values.showRepeatedPassword)}
              >
                {values.showRepeatedPassword ? <MdiEyeOff /> : <MdiEye />}
              </button>
            }
          />
        </div>

        <div className="or-auth-form__group">
          <OrButton type="submit" fullWidth isLoading={isSubmitting} size="lg" variant="primary">
            Restablecer la contraseña
          </OrButton>
        </div>
      </form>
    );
  };

  const validationsForm = {
    password: yup
      .string()
      .min(8, "La contraseña es demasiado corta. debe tener un mínimo de 8 caracteres.")
      .required("La password es requerida"),
    confirmpassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Las contraseñas deben coincidir")
      .required("La password es requerida"),
  };

  const Form = withFormik({
    mapPropsToValues: ({ password, confirmpassword }) => {
      return {
        password: password || "",
        confirmpassword: confirmpassword || "",
      };
    },

    enableReinitialize: true,
    validationSchema: yup.object().shape(validationsForm),
    handleSubmit: async (values) => {
      let result = await recoverPasswordValidate({
        password: values.password,
        repetedPassword: values.confirmpassword,
        token: token,
      });

      if (result) {
        showOrToast("Contraseña cambiada");
        navigate("/login");
      }
    },
  })(FormView);

  return (
    <AuthShell
      title="Ya casi estás"
      subtitle="Indícanos cuál es tu nueva contraseña"
      footer={
        <>
          <p className="or-auth-form__hint">
            ¿Ya estás registrado? <Link to="/login">Inicia sesión</Link>
          </p>
          <a href="https://openreferences.com/aviso-legal/" target="_blank" rel="noreferrer">
            Términos y Condiciones
          </a>
        </>
      }
    >
      <Form />
    </AuthShell>
  );
}
